module.exports = __webpack_public_path__ + "img/thumbnail_ChinesePangolin_m_normal.aa84f4e3.png";